import PropTypes from 'prop-types';
import moment from 'moment';

FormattedDate.propTypes = {
  date: PropTypes.string,
  format: PropTypes.string,
};

export default function FormattedDate({date, format}) {
  return (
    <span>{date ? moment(Date.parse(date)).format(format || 'DD-MMM-YY') : '-'}</span>
  );
}